<template>
  <div class="startseite page-content container">

    <h1 class="d-none">Universitäts&shy;klinikum Frankfurt am Main</h1>

    <div class="row w-100">

      <div class="col-12 col-lg-6 col-xl-7 ps-lg-0 pe-lg-3">

        <h2>Herzlich Willkommen auf der Übergangs-Homepage des Universitätsklinikum Frankfurt!</h2>

        <p>Das Universitätsklinikum Frankfurt hat am 6. Oktober festgestellt, dass ein Hackerangriff auf sein System versucht
          wird. Deshalb haben wir als Vorsichtsmaßnahme unser Netzwerk vom Internet getrennt. Es gibt bisher keine Hinweise
          darauf, dass Daten verlorengegangen oder entwendet wurden.</p>

        <p>Unsere grundlegenden IT-Systeme funktionieren weiterhin.<br><strong>Das heißt, in der Krankenversorgung sind wir weiter für
          Sie da.</strong></p>

        <p>Aufgrund der Vorsichtsmaßnahme ist unsere reguläre Homepage allerdings nicht online. <span class="color-red">Unsere bisherigen
          E-Mail-Adressen&nbsp;(@kgu.de) sind ebenfalls derzeit nicht erreichbar.</span> Es wird noch einige Zeit dauern,
          bis wir wieder wie gewohnt und in vollem Umfang mit dem Internet verbunden sein werden. Am besten sind wir
          aktuell telefonisch zu erreichen. Auf dieser Übergangs-Homepage listen wir wesentliche Telefonnummern auf,
          mit denen Sie die einzelnen medizinischen Fachbereiche und weitere zentrale Stellen erreichen können.
          Zu vielen Bereichen bestehen mittlerweile auch alternative Kontaktmöglichkeiten per E-Mail.
          So verfolgen wir auch in dieser Zeit unser Ziel: Aus Wissen wird Gesundheit!</p>

      </div>

      <div class="col-12 col-lg-6 col-xl-5 bg-lightgray kgu-border" style="height:max-content">

        <div class="py-3 px-2">

          <h3 class="color-blue">Vermittlungs&shy;zentrale</h3>
          <p>T&nbsp;<a href="tel:+496963010">+49&nbsp;69&nbsp;63&nbsp;01&nbsp;–&nbsp;0</a><br>
             F&nbsp;069&nbsp;6301&nbsp;6301<br>
             E-Mail <a href="mailto:info@ukffm.de">info@ukffm.de</a></p>

          <router-link :to="'/fachabteilungen'" class="mb-0">
            <h3 class="mt-4 color-blue">Medizinische Fach&shy;abteilungen&nbsp;&#10132;</h3>
            <p style="font-weight:normal;">Direkte Durchwahlen</p>
          </router-link>

          <h3 class="mt-4 color-blue">Lob- und Beschwerde&shy;management</h3>
          <p><strong>Service- und Telefonzeiten</strong><br>
            Montag / Dienstag 09:00 – 11:30 Uhr<br>
            Donnerstag 12:30 – 15:30 Uhr
          </p>
          <p>T&nbsp;<a href="tel:+496963017145">+49&nbsp;69&nbsp;63&nbsp;01&nbsp;–&nbsp;7145</a><br>
             F&nbsp;+49&nbsp;69&nbsp;63&nbsp;01&nbsp;–&nbsp;3930</p>

          <h3 class="mt-4 color-blue">Patienten&shy;fürsprecherinnen</h3>
          <p><strong>Sprechzeiten</strong><br>
            Dienstag und Donnerstag 10:00 – 11:30 Uhr<br>
            Haus 1, 2. OG, Raum 222</p>
          <p>T&nbsp;<a href="tel:+496963015457">+49&nbsp;69&nbsp;63&nbsp;01&nbsp;–&nbsp;5457</a></p>

          <h3 class="mt-4 color-blue">Recruiting</h3>
          <p>T <a href="tel:+4969630180088">+49 69 6301-80088</a><br>
            E-Mail <a href="mailto:bewerbung@ukffm.de">bewerbung@ukffm.de</a><br>
            Jobbörse <a href="https://www.ukf-und-du.de">www.ukf-und-du.de</a></p>

          <h3 class="mt-4 color-blue">Pressestelle</h3>
          <p>T&nbsp;<a href="tel:+4969630186443">+49&nbsp;69&nbsp;63&nbsp;01&nbsp;–&nbsp;86443</a><br>
            E-Mail <a href="mailto:kommunikation@ukffm.de">kommunikation@ukffm.de</a></p>

          <p>Gesundheits&shy;forum<br>
            <a href="https://vimeo.com/channels/gesundheitsforumukf" target="_blank">vimeo.com/channels/gesundheitsforumukf</a><br>
            Livestream unter<br>
            <a href="https://vimeo.com/event/2509005" target="_blank">vimeo.com/event/2509005</a></p>

          <h3 class="mt-4 color-blue">Vorstand</h3>
          <p>Ärztliche Direktion <a href="mailto:aerztlichedirektion@ukffm.de">aerztlichedirektion@ukffm.de</a><br>
            Pflegedirektion <a href="mailto:pflegedirektion@ukffm.de">pflegedirektion@ukffm.de</a><br>
            Kaufmännische Direktion <a href="mailto:kaufmaennischedirektion@ukffm.de">kaufmaennischedirektion@ukffm.de</a></p>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Startseite',

  created() {
    document.title = this.$route.meta.title;
    window.scrollTo(0, 0);
  },
}
</script>
